import JSZip from "jszip"
import readXlsxFile from "read-excel-file"
import BaseApi from "../../api/api"
import { windowLock, windowRelease } from "../../utils/loader"

export const getWbkatrnLogData = () => {
  return BaseApi.logForKatrenWb().then((res) => {
    if (res.success) return res.data
    return []
  })
}

export const getYandexKtrnLogData = () => {
  return BaseApi.logForKatrenYandex().then((res) => {
    if (res.success) return res.data
    return []
  })
}

export const getOzonKatrnLogData = () => {
  return BaseApi.logForKatrenOzon().then((res) => {
    if (res.success) return res.data
    return []
  })
}

export const prepareXLSX = async (
  files: {
    [key: string]: JSZip.JSZipObject & {
      storage?: string
    }
  },
  mainFileName: string,
  maxDiffNum?: number,
  maxDiffPercent?: number,
) => {
  windowLock()
  const result: {
    [key: string]: {
      name: string
      amount: number
      price: number
      prices: { price: number; storage?: string }[]
    }
  } = {}
  let fileName = ""
  for (const key in files) {
    const file = files[key]
    // Проверка, что файл является обычным файлом (а не подкаталогом)
    if (!file.dir && key.split(".").pop() === "xlsx") {
      const data = await file.async("arraybuffer")
      const storage = file.storage || ""

      const dataFromXslx = await readXlsxFile<{
        name: string
        amount: number
        price: number
      }>(data, {
        schema: schemaDataFromKatren,
      })
      if (dataFromXslx.rows) {
        fileName +=
          (file.unsafeOriginalName && file.unsafeOriginalName + ";") || ""
        dataFromXslx.rows.forEach((el) => {
          const { name, amount, price } = el
          if (result[name]) {
            if (key === mainFileName) result[name].amount = amount

            result[name].price =
              price && result[name].price < price ? price : result[name].price

            if (amount && price) {
              result[name].prices.push({ price, storage })
            }
          } else {
            const prices = !!(amount && price) ? [{ price, storage }] : []

            if (key === mainFileName) {
              result[name] = { name, amount, price, prices }
            } else {
              result[name] = { name, amount: 0, price, prices }
            }
          }
        })
      }
    }
  }

  const data = Object.values(result).map((el) => {
    const prices = el.prices.map((el) => el.price).sort((a, b) => b - a)
    const minPrice = prices[prices.length - 1]
    let price = el.price

    if (maxDiffNum && maxDiffPercent && prices.length) {
      const newPrice = prices.find((el) => {
        return (
          el - minPrice <= maxDiffNum &&
          (el * 100) / minPrice - 100 <= maxDiffPercent
        )
      })

      if (newPrice) {
        price = newPrice
      }
    }

    return {
      name: el.name,
      amount: el.amount,
      price,
      priceInfo: el.prices,
    }
  })

  return { data, fileName }
}

export const prepareZip = async (file: File) => {
  const zip = new JSZip()
  const buffer = await file.arrayBuffer()
  await zip.loadAsync(buffer)
  const files = zip.files
  return files
}
export const schemaDataFromKatren = {
  Название: {
    prop: "name",
    type: String,
  },
  Остаток: {
    prop: "amount",
    type: Number,
  },
  "Цена за 1 уп.": {
    prop: "price",
    type: Number,
  },
}

export const preparePromoZip = async (
  zip: File,
): Promise<{ nmId: number; planPrice: number }[]> => {
  windowLock()
  try {
    return prepareZip(zip)
      .then((files) => {
        return Promise.all(
          Object.values(files).map((file) => file.async("arraybuffer")),
        )
      })
      .then((files) => {
        return preparePromoXlsx(files)
      })
  } catch (err) {
    return []
  } finally {
    windowRelease()
  }
}

export const preparePromoXlsx = async (
  files: (File | ArrayBuffer)[],
): Promise<{ nmId: number; planPrice: number }[]> => {
  try {
    windowLock()
    const result: Map<number, { nmId: number; planPrice: number }> = new Map()
    for (const file of files) {
      const data = await readXlsxFile<{ nmId: number; planPrice: number }>(
        file,
        {
          schema: schemaPromoDataForWB,
        },
      )

      if (data.rows) {
        data.rows.forEach((el) => {
          const { nmId, planPrice } = el
          if (nmId && planPrice) {
            if (result.has(nmId)) {
              const current = result.get(nmId)
              const newPrice = Math.max(current?.planPrice || 0, planPrice)
              result.set(nmId, { nmId, planPrice: newPrice })
            } else {
              result.set(nmId, { nmId, planPrice })
            }
          }
        })
      }
    }

    return Array.from(result.values())
  } catch (err) {
    return []
  } finally {
    windowRelease()
  }
}

export const schemaPromoDataForWB = {
  nmId: {
    prop: "nmId",
    type: Number,
  },
  planPrice: {
    prop: "planPrice",
    type: Number,
  },
}
